import {useQuery} from '@tanstack/react-query';
import {KnowledgeService} from 'client';

// Guides ship with the backend, so they only change on deploy.
const GUIDE_STALE_TIME_MS = 60 * 60 * 1000;

export const useKnowledgeGuides = () =>
  useQuery({
    queryKey: ['knowledge', 'guides'],
    queryFn: () => KnowledgeService.listKnowledgeGuidesApiV1KnowledgeGuidesGet(),
    staleTime: GUIDE_STALE_TIME_MS,
  });

export const useKnowledgeGuide = (guideId: string) =>
  useQuery({
    queryKey: ['knowledge', 'guides', guideId],
    queryFn: () => KnowledgeService.getKnowledgeGuideApiV1KnowledgeGuidesGuideIdGet(guideId),
    staleTime: GUIDE_STALE_TIME_MS,
    enabled: Boolean(guideId),
    retry: false,
  });
